import { objectTypes } from "src/consts/objectTypes";
import CreateInspectionForm from "src/components/Forms/CreateInspectionForm";

export default function CreateDeviation() {
  return (
    <CreateInspectionForm
      objectType={objectTypes.Deviation}
      formFields={["title", "description", "deviationType", "files"]}
    />
  );
}
